module.exports = __webpack_public_path__ + "static/media/sliderItem6.536d7a05.JPG";